export const roles = {
    admin: () => "Administrator",
    manager: () => "Manager",
    user: () => "User",
    restricted: () => "Restricted",
};
